import type { Configuration, Country } from '../graphql/codegen';
import type { FC, PropsWithChildren } from 'react';

import { ConsentProvider } from './dynamic/ConsentContext';
import { CookieProvider } from './dynamic/CookieContext';
import { ExperienceOptionsProvider } from './dynamic/ExperienceOptionsProvider';
import { MediaQueryContextProvider } from './dynamic/MediaQueryContext';
import { SearchContextProvider } from './dynamic/SearchContext';
import { UserProvider } from './dynamic/UserContext';
import { DataLayerProvider } from './static/DataLayerContext';
import { SpaPageLoad } from '~/components/shared/common/SpaPageLoad';
import type { GlobalTopLevelNavigationType } from '~/types/amplience';

type CommonContextListProps = PropsWithChildren<{
  configuration: Configuration;
  countryEn: Country;
  topLevelNavigationContent?: GlobalTopLevelNavigationType;
}>;

export const CommonContextList: FC<CommonContextListProps> = ({
  children,
  configuration,
  countryEn,
  topLevelNavigationContent,
}) => (
  <CookieProvider>
    <UserProvider>
      <ConsentProvider configuration={configuration}>
        <DataLayerProvider>
          <SpaPageLoad
            configuration={configuration}
            countryEn={countryEn}
            topLevelNavigationContent={topLevelNavigationContent}
          />
          <MediaQueryContextProvider>
            <ExperienceOptionsProvider>
              <SearchContextProvider configuration={configuration}>
                {children}
              </SearchContextProvider>
            </ExperienceOptionsProvider>
          </MediaQueryContextProvider>
        </DataLayerProvider>
      </ConsentProvider>
    </UserProvider>
  </CookieProvider>
);
